import axios from "axios";

const baseURL = "/api/cdk/print-receipts/v1";

const URL = {
  search: `${baseURL}/search`,
  listReceiptDetails: `${baseURL}/list-receipt-details`,
  sendEmail: `${baseURL}/send-email`
};

const HEADERS = {
  "Content-Type": "application/json"
};

const PrintReceiptsService = {
  search: async (documentIdentifier, customerNumber, customerName) => {
    const getParam = val => (val ? val : "");
    const url = `${URL.search}?documentIdentifier=${getParam(
      documentIdentifier
    )}&customerNumber=${getParam(customerNumber)}&customerName=${getParam(
      customerName
    )}`;
    const response = await axios.get(url, { headers: HEADERS });
    return response.data;
  },
  listReceiptDetails: async receipts => {
    const url = `${URL.listReceiptDetails}?transactionIds=${receipts
      .map(r => r.transactionId)
      .join(",")}`;
    const response = await axios.get(url, { headers: HEADERS });
    return response.data;
  },
  sendEmail: async (email, receipts) => {
    const url = `${URL.sendEmail}?email=${email}`;
    const response = await axios.post(url, receipts, { headers: HEADERS });
    return response.data;
  }
};

export default PrintReceiptsService;
